import './SportOverview.less';

import React, { FC, useContext, useEffect, useRef, useState } from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import { SvgIcon } from '../../../icons/SvgIcon';
import {
    getInfocentreEventId$,
    getInfocentreSportCode$,
    initSport$,
    isMarketSaveActive$$,
    match$$,
    matchIdsSortByTime$$,
    noMatchesForSport$,
    noSportAvailable$,
    selectedMarketIds$$,
    showTournament$$,
    snapshotLoaded$$,
    sportByName$$,
    sportBySportIdAll$$,
    sportMaxColumns$$,
    sportsSnapshotLoaded$,
    sportTitleByName$$,
    tournament$$,
    tournamentIds$$,
    tournamentMatchIds$$
} from '../push/overview/subs';
import {
    setFilterSport,
    setSelectedMarketIds,
    toggleSport,
    toggleTournament,
    tournamentsCollapsedInit
} from '../handlers';
import { getLayout, localizeMap, setSEO } from '../utils';
import { useSportTournamentsPush } from '../push/overview/hooks';
import { SORT_BY_START_TIME, SPORT_OVERVIEW_ID } from '../constants';
import Markets from './Markets';
import Match from './Match';
import Accordion from './Accordion';
import useMediaColsCount from '../hooks/useMediaColsCount';
import { isMobile } from 'react-device-detect';
import { generatePath, Redirect, useRouteMatch } from 'react-router-dom';
import clsx from 'clsx';
import { TURBO_LIVE_ROOT_PATH, TURBO_LIVE_SPORT_PATH } from '../../../common/routing';
import { MatchMediaProvider, useMatchMedia } from '../hooks/useMatchMedia';
import { allTournamentsCollapsed$$, loggedIn$, sortBy$, sportCollapsed$$, tournamentVisibilityCustom$$ } from '../subs';
import { useChannelStatusPush } from '../push/channelStatus/hooks';
import { FavoriteIcon, StatsIcon } from './MatchIcons';
import { useTurboLiveRouteParams } from '../routes';
import { useFavoriteTournament } from '../favorite/hooks';
import { SharedIntersectionObserverProvider } from '../../../hooks/shared-intersection-observer/provider';
import OverviewBetLoader from './OverviewBetLoader';
import { MatchesLoadingPlaceholder } from './overview/MatchesLoadingPlaceholder';
import TurboLiveContext from '../context/TurboLiveContext';
import InfoMsg from './InfoMsg';
import SportProvider from './SportProvider';
import { formatDate, isMobileChannel } from '../../../common/util';
import { startTLVOverviewInfocentre } from '../push/overview/handlers';
import ImportantInfo from '../../ImportantInfo/ImportantInfo';
import useScrollTop from '../hooks/useScrollTop';
import SettingsIcon from '../../../icons/SettingsIcon';
import { openDialog } from '../config';
import { Button } from '../../button/Button';
import { deleteFavoriteOverviewMarkets, saveFavoriteOverviewMarkets } from '../favorite/handlers';
import { MarketSelection } from './MarketSelection';
import { overviewMarketApiSucess$ } from '../favorite/subs';
import DefaultError from '../../errors/DefaultError/DefaultError';
import SuccessDialogBody from '../../dialogs/SuccessDialogBody';
import i18n from '../../../common/i18n';
import { BackToOverview } from './detail/MatchDetailScoreboard';
import { useLoadMatchtrackerTemplates } from '../../match-statistics/hooks/useLoadMatchtrackerTemplates';
import ToggleTournaments from './ToggleTournaments';
import useLogNotLoadedData from '../hooks/useLogNotLoadedData';
import { isProfileCombinableBetsEnabled, isProfileSportBracketEnabled } from '../../../profiles';
import { InfoModal } from '../../info-modal/InfoModal';
import SportHeader from '../../sportHeader/SportHeader';
import { SportIconNui } from '../../../icons/SportIconNui';
import { TournamentFlags } from '../../../icons/TournamentFlags';
import { getSportIdByName } from '../../../common/utils/utils';
import { SportBracketIcon } from '../../sportbracket/SportBracketIcon';

const SPORT_HEADER_NAME_CLASS = 'flex items-center flex-1 full-height';

export const Matches: FC<{ sportName: string; matchIds: any }> = ({ sportName, matchIds }) =>
    !matchIds ? (
        <MatchesLoadingPlaceholder />
    ) : (
        matchIds.map(matchId => <Match matchId={matchId} sportCode={sportName} key={matchId} />)
    );

export const TournamentOverview: FC<{ tournamentId: string; sportName: string }> = ({ tournamentId, sportName }) => {
    const { derefSub, subscribe } = useReframe();
    const tournament = derefSub(tournament$$(sportName, tournamentId));
    const allowCombinations = tournament?.get('allowMarketCombinations');
    const showTournament = derefSub(showTournament$$(sportName, tournamentId));
    const matchIds = derefSub(tournamentMatchIds$$(sportName, tournamentId));
    const tournamentVisibilityCustom = subscribe(tournamentVisibilityCustom$$(tournamentId, sportName));
    const allTournamentCollapsed = subscribe(allTournamentsCollapsed$$(sportName));
    const collapsed =
        (!allTournamentCollapsed && tournamentVisibilityCustom) ||
        (allTournamentCollapsed && !tournamentVisibilityCustom);
    const matchOverview = useRouteMatch({ path: TURBO_LIVE_SPORT_PATH, strict: true });
    if (!showTournament) {
        return null;
    }
    const sportId = getSportIdByName(sportName) || tournament?.get('sportId');
    const sportBracketId = tournament?.get('sportBracketId');
    const mobileChannel = isMobileChannel();
    const note = tournament?.get('note');
    const isOverview = matchOverview?.isExact;
    const showNoteIn = !mobileChannel && isOverview;
    const flags = tournament?.getIn(['icons', 'flags']);
    const teamLogos = tournament?.getIn(['icons', 'teamLogos']);
    const listOfIcons = flags?.merge(teamLogos);

    return (
        <Accordion
            otherClass={clsx('bg-white-ng p-rel px-10', { 'py-8': !mobileChannel })}
            accordionClass={clsx('tl-br-b sport-br-l', { 'bg-white-ng': !mobileChannel })}
            arrowColor={`fill-${sportId} sport-overview-ico`}
            onClick={() => dispatch(toggleTournament(tournamentId, sportName))}
            isTournamentCollapsed={collapsed}
            content={
                <>
                    <div className={`absolute-center bg-opacity bg-dark-${sportId}`} />
                    <div
                        className={clsx('p-abs tournament-absolute-right flex-center', mobileChannel ? 'mr-5' : 'ml-5')}
                    >
                        <span
                            className={clsx(
                                `flex-1 text-left flex items-center full-height ${isMobile ? 'fs-12' : 'fs-14'}`
                            )}
                        >
                            <TournamentFavorite tournament={tournament} sportName={sportName} />
                            {tournament ? (
                                <>
                                    <TournamentFlags listOfIcons={listOfIcons} />
                                    <TournamentName tournament={tournament} matchesCount={matchIds?.count()} />
                                </>
                            ) : (
                                <span className="bg-white-ng turbo-live-opacity d-inline-black py-5 px-30 br-radius-1em d-inline-block" />
                            )}
                            {isProfileCombinableBetsEnabled() && allowCombinations && (
                                <CombinableIconWithInfo btnClasses="mx-8 fs-0 py-5 px-5" />
                            )}
                            {isProfileSportBracketEnabled() && sportBracketId && (
                                <SportBracketIcon sportBracketId={sportBracketId} />
                            )}
                            {note && showNoteIn && (
                                <span className={'fs-12 ml-20 sport-note no-wrap'} data-atid="tournament-note">
                                    {localizeMap(note)}
                                </span>
                            )}
                        </span>
                        <TournamentIcons tournament={tournament} sportId={sportId} />
                    </div>
                </>
            }
        >
            {note && !showNoteIn && (
                <div
                    className="sport-overview-note bg-black-3 br-t-default-light c-black-50 px-10 ellipsis fs-12"
                    data-atid="tournament-note"
                >
                    {localizeMap(note)}
                </div>
            )}
            <Matches matchIds={matchIds} sportName={sportName} />
        </Accordion>
    );
};

const TournamentName: FC<{ matchesCount: number; tournament: any }> = ({ matchesCount, tournament }) => {
    const tournamentName = tournament.get('tournamentName');

    return (
        <>
            <span className="flex items-center ellipsis full-height c-black-100 text-extra-bold f-condensed ml-10">
                <span className="ellipsis">{localizeMap(tournamentName)}</span>
                {matchesCount && matchesCount > 1 && (
                    <span
                        title={i18n('nui.turbo.live.matchCount')}
                        className="p-rel fs-10 c-black-70 text-extra-bold match-badge pl-3"
                    >
                        {matchesCount}
                    </span>
                )}
            </span>
        </>
    );
};

export const CombinableIconWithInfo: FC<{ btnClasses?: string }> = ({ btnClasses }) => (
    <InfoModal imgId="combinable-bets" btnClasses={btnClasses}>
        <>
            <h3 className="text-extra-bold c-black-100 fs-14">{i18n('nui.combinable.bets.icon.modal.text.header')}</h3>
            <p className="c-black-40 pt-5 text-normal">{i18n('nui.combinable.bets.icon.modal.text1')}</p>
            <p className="c-black-40 pt-10 text-normal ">
                <div
                    className="d-inline-block"
                    dangerouslySetInnerHTML={{ __html: i18n('nui.combinable.bets.icon.modal.text2') }}
                />
                <a href={'https://www.nike.sk/clanky/viac-stavok-zo-zapasu-na-jednom-tikete'} className="pointer">
                    <span className="c-link-default"> {i18n('nui.combinable.bets.icon.modal.text.link')}</span>
                </a>
            </p>
        </>
    </InfoModal>
);

const TournamentFavorite: FC<{ sportName: string; tournament: any }> = ({ sportName, tournament }) => {
    const { isFavorite, toggleFavorite } = useFavoriteTournament(sportName, tournament);
    return tournament ? (
        <FavoriteIcon
            active={isFavorite}
            toggle={toggleFavorite}
            iconClass="sport-overview-ico-default sport-overview-ico mx-10"
            btnClass="sport-br-r"
            data-atid="tournament-favorite-icon"
        />
    ) : null;
};
const TournamentIcons: FC<{ sportId: string; tournament: any }> = ({ tournament, sportId }) =>
    tournament ? (
        <StatsIcon
            statisticsId={tournament.get('statisticsId')}
            btnClass="btn-no-pad"
            iconClass={`fill-${sportId} my-10 ${isMobileChannel() ? 'mx-10' : 'mx-8 sport-overview-ico'}`}
            isTournament
            usePlaceholder
        />
    ) : null;

const SportHeaderToggle: FC<{ sportName: string; collapseKey: string }> = ({ sportName, collapseKey }) => {
    const derefSub = useReframe();
    const collapsed = derefSub(sportCollapsed$$(sportName, collapseKey));
    return (
        <button onClick={() => dispatch(toggleSport(sportName, collapseKey))} className="self-start p-0 fs-0">
            <SvgIcon
                imgId={`live-collapse-tournaments${collapsed ? '-out' : ''}`}
                sizeX="20"
                sizeY="20"
                className="my-5"
            />
        </button>
    );
};

export const LiveSportHeader: FC<{ sportName; sportId?; otherClass?; collapseKey?: string; zIndex?: number }> = ({
    sportName,
    sportId,
    otherClass,
    collapseKey,
    zIndex
}) => {
    const derefSub = useReframe();
    const matchMedia = useMatchMedia();
    const sportData = derefSub(sportByName$$(sportName));
    const layout = sportData?.get('layout') || getLayout(sportName);
    const matchOverview = useRouteMatch({ path: TURBO_LIVE_SPORT_PATH, strict: true });
    const isOverview = matchOverview?.isExact;
    const mobileChannel = isMobileChannel();
    const localizedSportName = sportData && localizeMap(sportData.get('sportName'));
    const path = generatePath(TURBO_LIVE_SPORT_PATH, { sportName });
    const sportIdResolved = sportId || sportData?.get('id');
    const sportHeaderName = <SportHeaderName sportId={sportIdResolved} localizedSportName={localizedSportName} />;
    const showMarkets = isOverview || (!mobileChannel && matchMedia.x_1680);

    const ToggleComponent = () =>
        collapseKey ? (
            <SportHeaderToggle sportName={sportName} collapseKey={collapseKey} />
        ) : (
            <ToggleTournaments sportName={sportName} className="self-start px-5 py-5" />
        );
    return sportData ? (
        <SportHeader
            sportId={sportIdResolved}
            sportName={sportName}
            otherClass={clsx(
                otherClass,
                `c-white flex tl-br-b`,
                matchMedia.xxl || mobileChannel ? 'sport-header-md' : 'sport-header-sm',
                {
                    'sport-header-cols': !mobileChannel && isOverview,
                    'sport-header-sticky': mobileChannel,
                    'flex-1 p-rel': !mobileChannel
                }
            )}
            style={{ zIndex: mobileChannel ? null : zIndex }}
            hideBgr={mobileChannel}
        >
            <div
                className={clsx('flex items-center', {
                    'justify-center': !isOverview,
                    'turbo-live-first': !mobileChannel,
                    'turbo-live-col': mobileChannel,
                    'turbo-live-first-wide': matchMedia.x_1680 && !mobileChannel,
                    'turbo-live-first-super-wide': matchMedia.ultra && isOverview && !mobileChannel
                })}
            >
                {isOverview ? (
                    mobileChannel ? (
                        <ToggleTournaments sportName={sportName} className={SPORT_HEADER_NAME_CLASS}>
                            {sportHeaderName}
                        </ToggleTournaments>
                    ) : (
                        <div className={SPORT_HEADER_NAME_CLASS}>{sportHeaderName}</div>
                    )
                ) : (
                    <BackToOverview path={path} classes={SPORT_HEADER_NAME_CLASS}>
                        {sportHeaderName}
                    </BackToOverview>
                )}

                {isOverview && mobileChannel ? (
                    <SaveMarketsButton sportCode={sportName} sportId={sportIdResolved} />
                ) : null}
                {!isOverview && showMarkets && (
                    <div className="pb-15 pr-10">
                        <ToggleComponent />
                    </div>
                )}
            </div>

            <>
                {showMarkets && <Markets sportCode={sportName} />}
                {!mobileChannel && (
                    <div
                        className={clsx(
                            {
                                'turbo-live-last sport-header-last pr-10': isOverview,
                                'pt-10': matchMedia.xxl,
                                'pt-15': !isOverview,
                                'pt-5': !matchMedia.xxl
                            },
                            'flex justify-between'
                        )}
                    >
                        {isOverview && <SaveMarketsButton sportCode={sportName} sportId={sportIdResolved} />}
                        {(isOverview || !showMarkets) && <ToggleComponent />}
                    </div>
                )}
            </>
        </SportHeader>
    ) : (
        <>
            <SimpleSportHeader
                mobileChannel={mobileChannel}
                otherClass={otherClass}
                path={path}
                layout={layout}
                sportId={sportIdResolved}
            />
            <InfoMsg>{i18n('nui.turbo.live.filterNoEvents')}</InfoMsg>
        </>
    );
};

// Used when sport does not have any events because of filtering
const SimpleSportHeader: FC<{ otherClass; layout; path; sportId?: string; mobileChannel: boolean }> = ({
    otherClass,
    layout,
    path,
    sportId,
    mobileChannel
}) => {
    const matchMedia = useMatchMedia();
    const derefSub = useReframe();
    const sport = derefSub(sportBySportIdAll$$(sportId));
    const localizedSportName = localizeMap(sport?.get('sportName'));
    return sportId ? (
        <div
            className={clsx(
                'flex-center c-white sport-header',
                `bg-${sportId} sport-header-${layout}`,
                `${matchMedia.xxl || mobileChannel ? 'sport-header-md' : 'sport-header-sm'}`,
                otherClass
            )}
        >
            <BackToOverview path={path} classes={SPORT_HEADER_NAME_CLASS}>
                <SportHeaderName sportId={sportId} localizedSportName={localizedSportName} />
            </BackToOverview>
        </div>
    ) : (
        <div
            className={clsx(
                otherClass,
                `${matchMedia.xxl || mobileChannel ? 'sport-header-md' : 'sport-header-sm'} bg-${layout}`
            )}
        />
    );
};

const SportHeaderName: FC<{ sportId; localizedSportName: string }> = ({ sportId, localizedSportName }) => (
    <>
        <SportIconNui
            sportId={sportId}
            sizeX="24"
            sizeY="24"
            className={`c-white flex-shrink-0 ${isMobileChannel() ? 'ml-10' : 'ml-20'}`}
        />
        <h2 className="text-extra-bold noselect fs-21 ellipsis mx-10 f-condensed c-white">{localizedSportName}</h2>
    </>
);

export function SaveMarketsButton({ sportCode, sportId }) {
    const { showLoginModal } = useContext(TurboLiveContext);
    const derefSub = useReframe();
    const isUserLoggedIn = derefSub(loggedIn$);
    const mobileChannel = isMobileChannel();

    function openSaveMarketsDialog() {
        if (isUserLoggedIn) {
            openDialog(
                <div className="fs-18 text-extra-bold text-center px-30">
                    {i18n('nui.turbo.live.saveMarketsDialog.title')}
                </div>,
                <SaveMarketsDialogBody sportCode={sportCode} sportId={sportId} />,
                { priority: 1 }
            );
        } else {
            showLoginModal();
        }
    }

    return (
        <button
            className={clsx(mobileChannel ? 'flex items-start pt-15 px-10 full-height' : 'px-5 py-5 self-start')}
            onClick={openSaveMarketsDialog}
            data-atid="markets-settings-button"
        >
            <SettingsIcon classNames="c-white" width="20px" height="20px" />
        </button>
    );
}

export function openMarketsChangeSucessDialog() {
    openDialog(
        null,
        <SuccessDialogBody
            i18nTextCode={'nui.turbo.live.saveMarketsDialog.sucess'}
            i18nTitleCode={'nui.turbo.live.saveMarketsDialog.sucess.title'}
        />,
        {
            priority: 11,
            closeAll: true
        }
    );
}

const SaveMarketsDialogBody: FC<{ sportCode: string; sportId: string; close?: any }> = ({
    sportCode,
    sportId,
    close
}) => {
    const maxMediaCols = useMediaColsCount();
    const derefSub = useReframe();
    const selectedMarketIds = derefSub(selectedMarketIds$$(sportCode));
    const sportMaxCols = derefSub(sportMaxColumns$$(sportCode));
    const apiStatus = derefSub(overviewMarketApiSucess$);
    const onMarketSelected = index => marketId =>
        dispatch(setSelectedMarketIds(sportCode, selectedMarketIds.set(index, marketId)));
    const marketsCols = Math.min(sportMaxCols, maxMediaCols);
    const isSaveActive = derefSub(isMarketSaveActive$$(sportCode, marketsCols));
    const [saving, setSaving] = useState(false);

    return (
        <MatchMediaProvider>
            <div className={clsx({ 'save-markets-dialog': !isMobileChannel() })}>
                {selectedMarketIds?.take(marketsCols).map((marketId, index) => (
                    <MarketSelection
                        key={marketId + index}
                        marketId={marketId}
                        columnId={index}
                        sportName={sportCode}
                        onSelect={onMarketSelected(index)}
                        saveFavouritePopup
                    />
                ))}
                <button
                    className="my-30 fs-16 c-blue text-center full-width"
                    onClick={() => dispatch(deleteFavoriteOverviewMarkets(sportCode, sportId))}
                >
                    {i18n('nui.turbo.live.saveMarketsDialog.deleteText')}
                </button>
                {apiStatus !== undefined && !isSaveActive ? (
                    !apiStatus ? (
                        <DefaultError text={i18n('nui.turbo.live.saveMarketsDialog.failed')} />
                    ) : null
                ) : null}
                <div className="nui-button-row pt-20">
                    <Button
                        className="nui-button grey"
                        label={i18n('nui.button.cancel')}
                        onClick={() => {
                            close();
                        }}
                    />
                    <Button
                        className="nui-button-180 ml-20"
                        primary
                        label={i18n('nui.button.save')}
                        onClick={() => {
                            setSaving(true);
                            dispatch(saveFavoriteOverviewMarkets(sportCode, sportId, maxMediaCols));
                        }}
                        disabled={!isSaveActive}
                        loading={saving && apiStatus === undefined}
                    />
                </div>
            </div>
        </MatchMediaProvider>
    );
};

export const MatchesSortedByTime: FC<{ sportCode: string }> = ({ sportCode }) => {
    const derefSub = useReframe();
    const matchIds = derefSub(matchIdsSortByTime$$(sportCode));

    return <Matches matchIds={matchIds} sportName={sportCode} />;
};

export const SportMatches: FC<{ sportName: string }> = ({ sportName }) => {
    const derefSub = useReframe();
    const sortByStartTime = derefSub(sortBy$) === SORT_BY_START_TIME;
    const mobileStyle = isMobileChannel();
    const matchOverview = useRouteMatch({ path: TURBO_LIVE_SPORT_PATH, strict: true });
    const isOverview = matchOverview?.isExact;
    return (
        <>
            <div
                className={clsx(mobileStyle ? 'bg-black-10' : 'turbo-live-shadow', {
                    'bg-white-ng': !mobileStyle && sortByStartTime
                })}
            >
                {sortByStartTime ? (
                    <MatchesSortedByTime sportCode={sportName} />
                ) : (
                    <SportTournaments sportName={sportName} />
                )}
            </div>
            {isOverview && <ImportantInfo />}
        </>
    );
};

const SportTournaments: FC<{ sportName: string }> = ({ sportName }) => {
    const derefSub = useReframe();
    const tournamentIds = derefSub(tournamentIds$$(sportName));
    useEffect(() => dispatch(tournamentsCollapsedInit(sportName)), [sportName]);

    return (
        tournamentIds?.map(tournamentId => (
            <TournamentOverview tournamentId={tournamentId} sportName={sportName} key={tournamentId} />
        )) || <TournamentOverview tournamentId={null} sportName={sportName} />
    );
};

export const overviewScrollY = () => document.getElementById(SPORT_OVERVIEW_ID)?.scrollTop;

const SportOverviewMatches: FC<{ footer?; children?: any; sportName: string }> = ({ footer, children, sportName }) => {
    const [ref, id] = useScrollTop();
    const { derefSub } = useReframe();
    const localizedSport = derefSub(sportTitleByName$$(sportName));

    useEffect(() => {
        if (sportName) {
            setSEO(localizedSport);
            dispatch(setFilterSport(sportName));
            ref.current?.scrollTo(0, 0);
        }
    }, [ref, sportName, localizedSport]);
    const isMobileView = isMobileChannel();
    const intersectionObserverOptions = useRef<IntersectionObserverInit>({
        root: ref.current,
        rootMargin: '200px 0px 200px 0px',
        threshold: 0
    });
    return (
        <div
            id={id}
            ref={ref}
            data-atid="SportOverview"
            className={clsx('flex-1 flex flex-col', {
                'mr-5 pr-5 overflow-scroll optimize-scroll': !isMobileView
            })}
        >
            {children}
            <SharedIntersectionObserverProvider options={intersectionObserverOptions.current}>
                <SportMatches sportName={sportName} />
                {footer}
            </SharedIntersectionObserverProvider>
        </div>
    );
};

function noMatchesMessage(matchData): { msg: string; date: string } {
    if (matchData?.startTime) {
        const matchDate = new Date(matchData.startTime);
        const matchDateDay = matchDate.getDate();
        const todayDateDay = new Date().getDate();

        if (matchDateDay === todayDateDay) {
            return {
                msg: 'nui.turbo.live.noLiveMatchesActual',
                date: formatDate(matchDate, 'HH:mm')
            };
        } else {
            return { msg: 'nui.turbo.live.noLiveMatchesToday', date: formatDate(matchDate, 'DD.MM.YYYY HH:mm') };
        }
    }
    return { msg: 'nui.turbo.live.noLiveMatches', date: '' };
}

export const NoSportAvailable: FC<{ footer?: any }> = ({ footer }) => {
    const { getNextMatchData } = useContext(TurboLiveContext);
    const [matchData, setMatchData] = useState({
        matchId: undefined,
        sportId: undefined,
        startTime: undefined
    });
    useEffect(() => {
        getNextMatchData().then(response => setMatchData(response));
    }, [getNextMatchData]);
    const { msg, date } = noMatchesMessage(matchData);

    return (
        <>
            <InfoMsg>{i18n(msg) + ` ${date}`}</InfoMsg>
            <ImportantInfo />
            {footer}
        </>
    );
};

const ReloadToAnotherSport: FC = () => {
    const derefSub = useReframe();
    const newSport = derefSub(initSport$);

    const urlParam = newSport ? `/${newSport}` : '';

    return <Redirect to={`${TURBO_LIVE_ROOT_PATH}${urlParam}`} />;
};

const SportOverviewContent: FC<{ footer?: any; sportName: string }> = ({ footer, sportName }) => {
    useLoadMatchtrackerTemplates(isMobileChannel());
    useSportTournamentsPush(sportName);
    useChannelStatusPush();
    useLogNotLoadedData(sportName);
    const derefSub = useReframe();
    const infocentreSportCode = derefSub(getInfocentreSportCode$);
    const isSnapshotLoaded = derefSub(snapshotLoaded$$(sportName));
    const noMatchesForSport = derefSub(noMatchesForSport$(sportName));
    const infocentrumEventId = derefSub(getInfocentreEventId$);
    const isInfocentrumMatchInOverview = derefSub(match$$(sportName, infocentrumEventId));
    const sportId = getSportIdByName(sportName);

    useEffect(() => {
        if ((isSnapshotLoaded && infocentreSportCode !== sportName) || !isInfocentrumMatchInOverview) {
            dispatch(startTLVOverviewInfocentre(sportName));
        }
    }, [isSnapshotLoaded, sportName, infocentreSportCode, isInfocentrumMatchInOverview]);
    if (noMatchesForSport || sportName === 'undefined') {
        return <ReloadToAnotherSport />;
    }

    return (
        <SportProvider sportName={sportName}>
            <OverviewBetLoader sportCode={sportName} />
            {isMobileChannel() ? (
                <LiveSportHeader sportName={sportName} />
            ) : (
                <div className="flex full-width">
                    <LiveSportHeader sportName={sportName} sportId={sportId} />
                    <div className={`overflow-scroll tl-br-b pr-10 bg-${sportId}`} />
                </div>
            )}
            <SportOverviewMatches footer={footer} sportName={sportName} />
        </SportProvider>
    );
};

const SportOverview: FC<{ footer?: React.ReactNode }> = ({ footer }) => {
    let { sportName } = useTurboLiveRouteParams();
    const derefSub = useReframe();
    const initSport = derefSub(initSport$);
    const noSportAvailable = derefSub(noSportAvailable$);
    const sportsSnapshotLoaded = derefSub(sportsSnapshotLoaded$);
    sportName = sportName || initSport;

    if (noSportAvailable && sportsSnapshotLoaded) {
        return <NoSportAvailable footer={footer} />;
    }

    if (noSportAvailable && !sportsSnapshotLoaded) {
        return <MatchesLoadingPlaceholder count={3} sportName={sportName} />;
    }

    return <SportOverviewContent footer={footer} sportName={sportName} />;
};

export default SportOverview;
